<template>
  <div class="list">
    <!-- <el-menu :default-active="listQuery.status" class="el-menu-demo" mode="horizontal" @select="handleStatus">
            <el-menu-item index="">全部</el-menu-item>
            <el-menu-item index="1">首页推荐</el-menu-item>
            <el-menu-item index="2">产品推荐</el-menu-item>
        </el-menu> -->

    <el-form :inline="true" size="small" :model="listQuery" class="demo-form-inline">
      <el-form-item label="搜索内容">
        <el-input
          v-model="listQuery.keyword_search"
          clearable
          style="width: 300px"
          class="name-input"
          placeholder="请请输入标题或摘要搜索"
        />
      </el-form-item>
      <el-form-item class="add">
        <el-button type="primary" size="small" @click="onAddSet">确定选择</el-button>
        <!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="onAddScrollClick">新建</el-button> -->
      </el-form-item>
    </el-form>

    <el-table
      v-loading="listLoading"
      :data="list"
      border
      style="width: 100%"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <!-- 首页推荐 -->
      <!-- <el-table-column v-if="listQuery.status==1" prop="sort" label="选择" width="80" align="center">
                <template slot-scope="scope">
                    <el-checkbox-group v-model="choiceRadio">
                        <el-checkbox :disabled="disabd(scope.row.id)" :label="scope.row.id">{{ content }}</el-checkbox>
                    </el-checkbox-group>
                </template>
            </el-table-column> -->
      <!-- 产品推荐 -->
      <!-- <el-table-column v-if="listQuery.status==2" prop="sort" label="选择" width="80" align="center">
                <template slot-scope="scope">
                    <el-checkbox-group v-model="choiceRadio">
                        <el-checkbox :disabled="disabd(scope.row.id)" :label="scope.row.id">{{ content }}</el-checkbox>
                    </el-checkbox-group>
                </template>
            </el-table-column> -->
      <el-table-column prop="sort" label="选择" width="80" align="center">
        <template slot-scope="scope">
          <el-checkbox-group v-model="choiceRadio">
            <el-checkbox :disabled="disabd(scope.row.id)" :label="scope.row.id">{{ content }}</el-checkbox>
          </el-checkbox-group>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="序号" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ (listQuery.page_index - 1) * listQuery.page_size + scope.$index + 1 }}</span>
        </template>
      </el-table-column>

      <el-table-column label="标题" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="摘要" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.abstract }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="icon" label="封面" align="center">
        <template slot-scope="scope">
          <el-image
            style="height: 120px"
            fit="contain"
            :src="imgDomain + scope.row.icon"
            :preview-src-list="[imgDomain + scope.row.icon]"
          />
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="上传日期" width="180" align="center" />
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.status === 1 ? "上架" : "下架" }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="page">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page_index"
        :limit.sync="listQuery.page_size"
        @pagination="getList"
      />
    </div>
  </div>
</template>
<script>
import { industryInsightList, SetIndustryInsightRec } from "@/api/content";
import Pagination from "@/components/Pagination";
import { imgDomain } from "@/configs/env";
import operations from "../../mixins/operations";
import { exists } from "fs";

export default {
  components: { Pagination },
  filters: {
    filterType(val) {
      switch (Number(val)) {
        case 1:
          return "首页";
          break;
        case 2:
          return "产品主页";
          break;
        case 4:
          return "关于我们";
          break;
        case 5:
          return "用户画像";
          break;
        case 7:
          return "数字营销";
          break;
        case 8:
          return "经营分析";
          break;
        case 9:
          return "定制化&私有化";
          break;
        case 10:
          return "案例主页";
          break;
      }
    },
  },
  mixins: [operations],
  data() {
    return {
      imgDomain,
      list: [],
      total: 0,
      listQuery: {
        page_index: 1,
        page_size: 10,
      },
      listLoading: false,
      choiceRadio: [],
      // 是否单选
      isRadio: {
        type: Boolean,
        default: false,
      },
      multipleSelection: [],
      content: "",
    };
  },
  computed: {
    disabd() {
      return function (id) {
        let isTrue; // true不可选
        if (this.choiceRadio.length == 3) {
          // 'this.choiceRadio.findIndex(t => t == id)'查找数组this.choiceRadio里面有选中的id，
          // 有的话就返回对应元素的下标，无就返回-1
          const is = this.choiceRadio.findIndex((t) => t == id);
          console.log(this.choiceRadio, is, 23423);
          if (is == -1) {
            isTrue = true; // 不可选
            // return false;
          } else {
            isTrue = false; // 可选
          }
        } else {
          isTrue = false;
        }
        console.log(isTrue, 11111);
        return isTrue; // 返回true或false
      };
    },
    hasAdd() {
      return this.operations.includes("新建轮播图");
    },
    hasUp() {
      return this.operations.includes("上架轮播图");
    },

    hasDown() {
      return this.operations.includes("下架轮播图");
    },
    hasEdit() {
      return this.operations.includes("编辑轮播图");
    },
    hasDelete() {
      return this.operations.includes("删除轮播图");
    },
  },

  async mounted() {
    const pageIndex = sessionStorage.getItem("page_index");
    if (Number(pageIndex)) {
      this.listQuery.page_index = Number(pageIndex);
    }
    this.getList();
  },
  methods: {
    async getList(params = this.listQuery) {
      this.listLoading = true;
      const { total, data } = await industryInsightList(params); // 替换成正确的请求接口
      this.listLoading = false;
      this.total = total;
      this.list = data;
      const pageIndex = sessionStorage.getItem("page_index");
      if (Number(pageIndex) && this.total > 0) {
        this.$nextTick(() => {
          var elPager = document.getElementsByClassName("number");
          for (let i = 0; i < elPager.length; i++) {
            if (i == pageIndex - 1) {
              elPager[i].classList.add("active");
            } else {
              elPager[i].classList.remove("active");
            }
          }
        });
      }
      sessionStorage.removeItem("page_index");
    },
    handleSelectionChange(val) {
      // console.log(val,1213123123123);
      this.multipleSelection = val;
      // if (val.length > 3) {
      //     return false;
      // } else {
      //     return true;
      // }
    },
    // handleStatus(val) {
    //     this.listQuery.status = val;
    //     this.getList()
    //     console.log(val, "44444")
    // },

    onAddScrollClick() {
      this.$router.push({ path: "/add-industry" });
    },
    onAddSet() {
      if (this.choiceRadio.length > 0) {
        const params = {
          type: "2",
          id: this.choiceRadio,
          option: "1",
        };
        SetIndustryInsightRec(params);
        this.$router.push({
          name: "/industry-case",
        });
      } else {
        this.$notify.error({ title: "请至少勾选一个" });
      }
    },
    handleEditClick(row) {
      sessionStorage.setItem("page_index", this.listQuery.page_index);
      this.$router.push({
        name: "/add-carousel",
        query: { uuid: row.id },
      });
    },

    async handleUpClick(row) {
      const res = await bannerShowScroll(row.id);
      if (res == true) {
        this.$notify.success({ title: "操作成功" });
      }
      this.getList();
    },

    async handleDeleteClick(id) {
      this.$confirm("确认删除此轮播图?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.submitDeleteClick(id);
        })
        .catch(() => {});
    },

    async submitDeleteClick(id) {
      const res = await deleteScroll(id);
      if (res == true) {
        this.$notify.success({ title: "操作成功" });
        this.getList();
      } else {
        this.$notify.success({ title: "操作失败" });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-menu-demo {
  margin-bottom: 20px;
}
.el-form-item {
  margin-right: 30px;
}
.add {
  float: right;
  margin-right: 0;
}

.el-pager li.active {
}
</style>
